import React from 'react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import { DefaultPropertyType } from '../../../../interface/core';

import Styles from './index.module.scss';

type MenuType = 'navlink' | 'anchor';

export type TabItemPropsType = DefaultPropertyType & {  
  url?: string;
  isDisabled?: boolean;
  isActive?: boolean;
  nodeType?: MenuType;
  icon?:React.ReactNode;
  onClick?: (key: string) => void;
}

const TabItem: React.FC<TabItemPropsType> = ({
  label,
  value,
  url,
  nodeType = 'navlink',
  isDisabled,
  isActive,
  onClick
}) => {

  const getButtonClassName = () => {
    if (isActive) {
      return isDisabled ? Styles.disabledActive : Styles.active;
    }
    return isDisabled && Styles.disabled;
  }

  const getLink = () => {
    if (nodeType === 'navlink') {
      return (
        <div className={Styles.aContainer}>
          <NavLink
            activeClassName={cn(Styles.active, isDisabled && Styles.disabledActive)}
            className={cn(Styles.container, isDisabled && Styles.disabled)}
            to={url || ''}
            exact={true}
          >
            {label}
          </NavLink>
        </div>
      )
    } else {
      return (
          <div className={Styles.aContainer}>
            <a
              href={url as string}
              className={cn(Styles.container, isDisabled && Styles.disabled)}
              >
              {label}
            </a>
          </div>
      )
    }
  }

  const getButton = () => (
    <button
      className={cn(
        Styles.container,
        getButtonClassName()
      )}
      onClick={() => onClick && onClick(value as string)}
    >
      {label}
    </button>
  )

  return (
    <>
      {
        url ? getLink() : getButton()
      }
    </>
  )
}

export default TabItem;
